module.exports = __webpack_public_path__ + "static/images/backpack-bg.ec2138e.png";